import RoutesContainer from '../RoutesContainer/RoutesContainer';

function RutasIngrales({ list }) {
  return (
    <RoutesContainer
      title={parseText('rutasServicios.tabs.header.serviciosIntegralesSalud.title')}
      description={parseText('rutasServicios.tabs.header.serviciosIntegralesSalud.description')}
      icon={parseText('rutasServicios.icons.serviciosIntegralesSalud')}
      serviceList={list.filter((item) => item.esRutaIntegral === true)}
    />
  );
}

export default RutasIngrales;
